module.exports = __webpack_public_path__ + "static/media/03_Partybox_1000_AR_icon_preview.b8ba76e4.png";